/* eslint-disable css-modules/no-unused-class */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, defineMessages, intlShape } from 'react-intl';
import cx from 'classnames';
import HotelType from '../../data/types/HotelType';

import s from './HotelNameOverlay.css';

const messages = defineMessages({
  fullName: {
    id: 'hotel.full_name',
    defaultMessage: '##Red Planet {hotelName}##',
    description: 'Hotel full name. Do not translate or remove {hotelName}',
  },
});

class HotelNameOverlay extends React.Component {
  static propTypes = {
    hotel: HotelType.shape(),
  };

  static contextTypes = {
    intl: intlShape,
  };

  static defaultProps = {
    hotel: {
      name: '',
    },
  };

  render() {
    const {
      hotel: { name },
    } = this.props;
    return (
      <div className={cx(s.root, s[this.context.intl.locale])}>
        <div className={s.name}>
          <h1>
            <FormattedMessage
              {...messages.fullName}
              values={{
                hotelName: <span className={s.white}>{name}</span>,
              }}
            />
          </h1>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(HotelNameOverlay);
